var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"appcompetences_footer_suivant",attrs:{"to":_vm.ecrantSuivant}},[_vm._v("Passer cette question >")])
}
var staticRenderFns = []

export { render, staticRenderFns }